// extracted by mini-css-extract-plugin
module.exports = {"products":"oQ","oosMessaging":"pQ"};